import { Tables } from "@/integrations/supabase/types";

export const getLatestTipPath = (tips: Tables<"tips">[] | undefined): string => {
  if (!tips) return "/archive";
  
  const latestTip = tips
    .filter(tip => tip.is_published)
    .sort((a, b) => new Date(b.published_at || b.created_at).getTime() - new Date(a.published_at || a.created_at).getTime())[0];
  
  return latestTip ? `/tips/${latestTip.id}` : "/archive";
};